export const VIP_USD_THRESHOLDS = {
	silver: 400,
	gold: 1200,
	retentionRatio: 0.95,
} as const;

export const VIP_SILVER_USD_THRESHOLD = VIP_USD_THRESHOLDS.silver;
export const VIP_GOLD_USD_THRESHOLD = VIP_USD_THRESHOLDS.gold;

export const VIP_SILVER_USD_FALLBACK_THRESHOLD = Math.floor(
	VIP_SILVER_USD_THRESHOLD * VIP_USD_THRESHOLDS.retentionRatio,
);
export const VIP_GOLD_USD_FALLBACK_THRESHOLD = Math.floor(
	VIP_GOLD_USD_THRESHOLD * VIP_USD_THRESHOLDS.retentionRatio,
);

export const formatVipUsdThreshold = (value: number) =>
	`$${value.toLocaleString("en-US")}`;
